var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 10,
    viewBox: "0 0 113 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 10,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "genieworks_homepage_\xEB\xB9\x84\xEC\xA6\x88\xEB\x8B\x88\xEC\x8A\xA4_\xEC\xBB\xA4\xEB\xA8\xB8\xEC\x8A\xA4\xEB\x84\xA4\xED\x8A\xB8\xEC\x9B\x8C\xED\x81\xAC_\xEC\xB5\x9C\xEC\xA2\x85",
    clipPath: "url(#clip0_2514_18351)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 7906,
    transform: "translate(-720 -2385)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 5388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "genieworks_homepage_drafts_002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 960,
    transform: "translate(-720 -2385)",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "main02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 29",
    x: -717,
    y: -474,
    width: 1920,
    height: 960,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "bg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-330 -1480.47V-1255.94V3063H810V-1362V-1526V-1705H-38V-1704.93C-40.437 -1704.98 -42.8815 -1705 -45.3333 -1705C-182.774 -1705 -297.465 -1628.18 -324.144 -1526H-330V-1486.08V-1480.47Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 2609062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEC\x85\x80\xEB\x9F\xAC\xEB\x93\x9C \xEB\x8F\x84\xED\x98\x95"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 242",
    cx: -117,
    cy: -2,
    r: 137,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arrow 28",
    d: "M112.46 5.45964C112.713 5.2058 112.713 4.79424 112.46 4.5404L108.323 0.403827C108.069 0.149986 107.658 0.149986 107.404 0.403827C107.15 0.657667 107.15 1.06922 107.404 1.32307L111.081 5.00002L107.404 8.67698C107.15 8.93082 107.15 9.34237 107.404 9.59621C107.658 9.85006 108.069 9.85006 108.323 9.59621L112.46 5.45964ZM-1.05517e-07 5.65L112 5.65002L112 4.35002L1.05517e-07 4.35L-1.05517e-07 5.65Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2514_18351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 7906,
    fill: "white",
    transform: "translate(-720 -2385)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.27f6fb3ae8080976fb4549948ee911c5.svg";
export { ForwardRef as ReactComponent };